import { Check, LinkIcon, LoaderCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import { useState } from 'react';
// ShareModal 컴포넌트 정의
interface ShareModalProps {
  url: string;
  members: any[];
  currentUserName: string | undefined;
  groupName: string | undefined;
  closeModal: () => void;
  password: string | null;
}

const ShareModal: React.FC<ShareModalProps> = ({ url, members, currentUserName, groupName, closeModal, password }) => {
  const [isShowCopiedMessage, setIsShowCopiedMessage] = useState(false);
  const canShare = navigator.share !== undefined;

  const handleShare = () => {
    // 모바일 환경에서 Web Share API 사용
    if (canShare) {
      navigator.share({
        title: `${groupName} 초대`,
        text: `${currentUserName}님이 ${groupName} 그룹에 초대합니다!`,
        url: url
      })
      .then(() => closeModal())
      .catch(err => console.error('공유 실패:', err));
    } else {
      // 데스크톱 환경에서 클립보드에 복사
      navigator.clipboard.writeText(url)
        .then(() => {
          toast.success('링크가 클립보드에 복사되었습니다');
          setIsShowCopiedMessage(true);
          setTimeout(() => {
            setIsShowCopiedMessage(false);
          }, 2000);
        })
        .catch(err => {
          console.error('클립보드 복사 실패:', err);
          toast.error('링크 복사에 실패했습니다');
        });
    }
  };

  return (
    <div className=" max-w-md w-full">
      <h2 className="w-full text-gray-800 text-[22px] font-bold mb-4">멤버 초대하기</h2>
      <p className="text-gray-500 mb-4 line">구성원들이 그룹에 들어올 수 있도록<br/>초대링크를 공유해주세요!</p>
      <div className="max-h-[35vh] overflow-y-auto mb-4">
        <ul className="font-bold text-lg bg-[#F1F6FF] rounded-xl overflow-hidden px-3">
          {members.map((member, index) => (
            <li key={index} className="flex items-center justify-between py-3 not-last:border-b border-[#DEEBFF]">
              <span className="text-gray-800">{member.user_name}</span>
              {member.user_id !== null ? (
                <div className="flex items-center text-blue-500">
                  <Check className="w-5 h-5 mr-1 stroke-[2.5px]" />
                  <span className="">참여중</span>
                </div>
              ) : (
                <div className="flex items-center text-gray-500">
                  <LoaderCircle className="w-5 h-5 mr-1 animate-spin stroke-[2.5px]" />
                  <span className="">대기중</span>
                </div>
              )}
            </li>
          ))}
        </ul>
        {
          password && (
          <div className='mt-2 w-full p-3 font-bold bg-gray-50 text-gray-800 rounded-xl overflow-hidden flex justify-between items-center'>
            <span>비밀번호</span>
            <span className='text-blue-500'>{password}</span>
          </div>
        )}
        <p className="absolute -bottom-8 left-0 right-0 text-center text-gray-300">
          *링크가 외부에 유출되지 않도록 조심해주세요!
        </p>
      </div>
      <button 
        onClick={handleShare} 
        className="w-full bg-blue-500 text-white font-semibold text-lg py-3.5 px-4 rounded-xl flex items-center justify-center gap-1"
      >
        {isShowCopiedMessage ? '링크 복사 완료' : canShare ? '초대 링크 공유하기' : '초대 링크 복사하기'} <LinkIcon className="w-4 h-4 stroke-[3.5px]" />
      </button>
    </div>
  );
};

export default ShareModal;